export default {
  title: 'Transaction Reports',
  tabs: {
    position: 'Position Sheet',
    limit: 'Limit Order',
    closed: 'Close Order',
    deal: 'Deal Order',
  },
  filter: {
    keywordPlaceholder: 'Client ID, Nickname, Email',
    orderIdPlaceholder: 'MT Account, Order ID',
    dataRangePlaceholder: 'Data Range',
    tradeTypePlaceholder: 'Trade Command',
    dateRangeOpenPlaceholderStart: 'Open Time',
    dateRangeOpenPlaceholderEnd: 'Open Time',
    dateRangeOrderPlaceholderStart: 'Order Time',
    dateRangeOrderPlaceholderEnd: 'Order Time',
    search: 'Search',
    reset: 'Reset',
    dataRangeOptions: {
      all: 'All Brokers',
      self: 'Self',
      direct: 'Direct Subordinate',
      indirect: 'Indirect Subordinate',
    },
    tradeType: {
      all: 'All Types',
      open: 'Open',
      close: 'Close',
      buy: 'Buy',
      sell: 'Sell',
      limitBuy: 'Buy Limit',
      limitSell: 'Sell Limit',
      stopBuy: 'Buy Stop',
      stopSell: 'Sell Stop',
    },
  },
  table: {
    customerId: 'Client ID',
    nickname: 'Nickname',
    email: 'Email',
    mtAccount: 'MT Account',
    symbol: 'Symbol',
    orderId: 'Order ID',
    type: 'Type',
    volume: 'Volume',
    openPrice: 'Open Price',
    currentPrice: 'Current Price',
    stopProfit: 'Take Profit',
    stopLoss: 'Stop Loss',
    openTime: 'Open Time',
    interest: 'Interest',
    profit: 'Profit',
    fee: 'Commission',
    closePrice: 'Close Price',
    closeTime: 'Close Time',
    orderPrice: 'Order Price',
    orderTime: 'Order Time',
    trend: 'Trend',
    typeText: {
      buy: 'Buy',
      sell: 'Sell',
      limitBuy: 'Buy Limit',
      limitSell: 'Sell Limit',
      stopBuy: 'Buy Stop',
      stopSell: 'Sell Stop',
    },
    trendValues: {
      in: 'in',
      out: 'out',
    },
  },
  stats: {
    volume: 'Volume',
    interest: 'Interest',
    fee: 'Commission',
    floatingProfit: 'Floating P/L',
    totalProfit: 'Total P/L',
    orderProfit: 'Order P/L',
  },
}
